<template>
  <el-dialog v-model="appStore.showLogin" width="80%" append-to-body>
    <el-tabs v-if="appStore.showLogin" v-model="activeName" type="card" class="demo-tabs">
      <el-tab-pane label="单点登录" name="sso">
        <iframe class="h-[600px] w-full" :src="loginUrl" />
      </el-tab-pane>
      <el-tab-pane label="其他" name="cpt">
        <div class="h-[600px]"><Login /></div>
      </el-tab-pane>
    </el-tabs>
  </el-dialog>
</template>
<script setup lang="ts">
import Cookies from 'js-cookie';
import Login from './Login.vue';
import { useAppStore } from '@/stores/app';
const activeName = ref('sso');
const appStore = useAppStore();
const loginUrl = ref('');
const url = 'https://gsso.giikin.com/admin/login/logout.html?_system=18&_url=';
const login = () => {
  const protocol = window.location.protocol;
  const host = window.location.host;
  const myPath = window.location.pathname;
  loginUrl.value = `${url + protocol}//${host}${myPath}`;
  console.log(loginUrl.value);
};
watch(
  () => appStore.showLogin,
  value => {
    if (value) {
      login();
    }
  },
);
onMounted(() => {
  console.log(import.meta.env.MODE);
  if (appStore.showLogin) {
    login();
  }
  // iframe事件监听
  window.addEventListener('message', e => {
    // 刷新登录状态
    if (e.data.type === 'giikin-Logged') {
      const token = Cookies.get('token');
      if (
        // 测试环境  但是需要登录的情况
        (import.meta.env.MODE !== 'production' && e.data?.data?.token) ||
        // 正式环境 登录成功  但是服务器token设置失败
        (import.meta.env.MODE === 'production' && !token && e.data?.data?.token)
      ) {
        // 设置 Cookie 过期时间为 3 小时
        const now = new Date();
        let time = now.getTime();
        time += 10800 * 1000; // 3 小时之后的时间（单位：毫秒）
        now.setTime(time);
        Cookies.set('token', e.data.data.token, {
          expires: now,
          domain: import.meta.env.MODE === 'production' ? '.giikin.com' : undefined,
        });
        // 触发登录成功监听
        if (e.data?.data?.token) {
          appStore.triggerLoginResult(e.data.data);
        }
      }
      console.log(e, token);
      appStore.showLogin = false;
    }
  });
});
</script>
